export default function BrandingFooter() {
  return (
    <p className="pt-8 pb-2 text-center text-[11px] text-text-secondary/70">
      Made with <span className="text-error">❤</span> by AgentykCo™
    </p>
  );
}
